import { render } from "./Projections.vue?vue&type=template&id=65ccf91b&scoped=true"
import script from "./Projections.vue?vue&type=script&lang=js"
export * from "./Projections.vue?vue&type=script&lang=js"

import "./Projections.vue?vue&type=style&index=0&id=65ccf91b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ccf91b"]])

export default __exports__